package one.healthium.insights.ui.components.items

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.unit.dp
import one.healthium.domain.common.Insets
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ColorModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.components.AnchorState
import one.healthium.insights.ui.components.ContentEntryItem
import one.healthium.insights.ui.utils.resolve
import one.healthium.ui.common.utils.toPaddingValues
import one.healthium.ui.compose.theme.AppTheme
import androidx.compose.ui.tooling.preview.Preview

@Composable
fun ContentDecorator(
    modifier: Modifier = Modifier,
    entry: ContentEntry.Decorator,
    anchorState: AnchorState,
    onActionClicked: (ActionModel) -> Unit,
    isMetrics: Boolean,
    actionButton: String? = null,
    onTextActionClicked: () -> Unit = {},
) {
    Box(
        modifier
            .padding(entry.margins.toPaddingValues())
            .background(
                color = entry.backgroundColor?.resolve() ?: Color.Transparent,
                shape = entry.cornerRadius?.let { RoundedCornerShape(it.dp) } ?: RectangleShape
            )
            .padding(entry.insets.toPaddingValues())
            .clickable(
                enabled = entry.action != null,
                onClick = { entry.action?.let(onActionClicked) }
            )
    ) {
        ContentEntryItem(
            entry = entry.content,
            anchorState = anchorState,
            onActionClicked = onActionClicked,
            actionButton = actionButton,
            onTextActionClicked = onTextActionClicked,
            isMetrics = isMetrics,
        )
    }
}

@Composable
@Preview(showBackground = true)
private fun ContentDecorator() {
    AppTheme {
        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
            ContentDecorator(
                entry = ContentEntry.Decorator(
                    insets = Insets(16, 16, 16, 16),
                    backgroundColor = ColorModel.Hex(0xFFE0E0E0),
                    cornerRadius = 8,
                    content = ContentEntry.PlainText(
                        text = "This is a decorated content entry.",
                        style = null,
                        insets = null,
                    ),
                    margins = null,
                    action = null,
                ),
                anchorState = AnchorState(),
                onActionClicked = {},
                isMetrics = false,
            )
        }
    }
}